import { IBaseModel, BaseModel } from '../base.model';
import { AppointmentState, AppointmentTypes } from '../../common/enums';

export interface IAppointment extends IBaseModel {
  description?: string;
  start_date?: string;
  end_date?: string;
  name?: string;
  appointment_state?: 'confirmed' | 'draft';
  fk_block?: number;
  fk_ticket?: number;
  ticketId?: number;
  character_problems?: number[];
  participants?: number[];
  independent_contractors?: number[];
  welcomings?: number[];
  type?: string;
}
export class AppointmentDto extends BaseModel implements IAppointment {

  static APPOINTMENT_TYPE_EVENT: string = 'event';
  static APPOINTMENT_TYPE_APPOINTMENT: string = 'appointment';

  description?: string;
  start_date?: string;
  end_date?: string;
  name?: string;
  appointment_state?: 'confirmed' | 'draft';
  fk_block?: number;
  fk_ticket?: number;
  ticketId?: number;
  character_problems?: number[];
  participants?: number[];
  independent_contractors?: number[];
  welcomings?: number[];
  type?: string;
  /**
   *
   */
  /**
   *
   */
  constructor(opt: IAppointment = {}) {

    super(opt);
    this.type = opt.type || AppointmentTypes.Appointment;
  }
}



// WEBPACK FOOTER //
// ./src/models/appointment/appointment.model.ts